"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = buildResponsiveSize;
var _fuseVariables = require("@tvg/fuse-variables");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function buildResponsiveSize(size) {
  // Array of breakpoints i.e. xxs, xs, s, m, l, xl, xxl
  var breakpointsList = Object.keys(_fuseVariables.breakpoints);

  // Array of valid viewports from size prop passed
  var viewports = _typeof(size) === 'object' && Object.keys(size).filter(function (item) {
    return breakpointsList.includes(item);
  });

  // Check if size prop passed is responsive based on viewports above
  var isResponsive = (viewports === null || viewports === void 0 ? void 0 : viewports.length) > 0;

  // Function to set CSS based on array of viewports
  var setViewportCss = function setViewportCss(cssForViewport) {
    if (!(viewports !== null && viewports !== void 0 && viewports.length)) {
      return '';
    }
    return viewports.reduce(function (acc, viewport) {
      var viewportSize = size[viewport];
      var viewportCss = "\n\t\t\t@media screen and (min-width: ".concat(_fuseVariables.breakpoints[viewport].minWidth, ") {\n\t\t\t\t").concat(cssForViewport(viewportSize), "\n\t\t\t}");
      return acc + viewportCss;
    }, '');
  };
  return [isResponsive, setViewportCss];
}